import React from 'react'
import PropTypes from 'prop-types'

class Card extends React.Component {
  static propTypes = {
    /* Card title */
    title: PropTypes.string,
    /* Custom classnames */
    className: PropTypes.string,
    /* Card content */
    children: PropTypes.node,
  }

  render() {
    const { title, className } = this.props

    return (
      <div className={`card-box ${className || ''}`} {...this.props}>
        {title ? <div className='card-title'>{title}</div> : ''}
        {this.props.children}
      </div>
    )
  }
}

export default Card

export { Card }
